<template>
  <div class="app-container">
    <el-card>
      <div class="filter-container">
        <el-input v-model="query.exam_name" placeholder="考试科目名称" style="width:200px;" class="filter-item" @keyup.enter.native="getList" />
        <el-select v-model="query.session_id" placeholder="招聘场次" style="width:200px;margin-right:10px" class="filter-item" clearable>
          <el-option v-for="item in sessionOptions" :key="item.id" :label="item.title" :value="item.id" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" :disabled="!multipleSelection.length" @click="handleBatchDelete">批量删除</el-button> -->
        <!-- <el-button icon="el-icon-download" @click="handleExport">导出</el-button> -->
      </div>
      <el-table :data="list" border v-loading="loading" style="margin-top:20px;" @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column prop="id" label="ID" width="60" align="center" >
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="session_title" label="招聘场次" >
          <template slot-scope="{row}">
            <span v-if="row.session_id">{{ row.session.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="exam_name" label="考试科目" />
        <el-table-column prop="position_name" label="招聘职位" >
          <template slot-scope="{row}">
            <template v-if="row.positions && row.positions.length">
              <span>{{ row.positions[0].position_name }}</span>
              <el-popover
                v-if="row.positions.length > 1"
                placement="top"
                trigger="hover"
                popper-class="position-popover"
              >
                <div class="position-list">
                  <div v-for="item in row.positions" :key="item.id" class="position-item">
                    {{ item.position_name }}
                  </div>
                </div>
                <el-button slot="reference" type="text" size="mini"> 更多</el-button>
              </el-popover>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="room_name" label="考场" >
          <template slot-scope="{row}">
            <template v-if="row.rooms && row.rooms.length">
              <span>{{ row.rooms[0].room_name }}</span>
              <el-popover
                v-if="row.rooms.length > 1"
                placement="top"
                trigger="hover"
                popper-class="room-popover"
              >
                <div class="room-list">
                  <div v-for="item in row.rooms" :key="item.id" class="room-item">
                    {{ item.room_name }}
                  </div>
                </div>
                <el-button slot="reference" type="text" size="mini"> 更多</el-button>
              </el-popover>
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="exam_content" label="考试内容" /> -->
        <el-table-column prop="start_time" label="开始时间" width="160" />
        <el-table-column prop="end_time" label="结束时间" width="160" />
        <el-table-column prop="total_seats" label="总座位数" width="100" align="center" />
        <!-- <el-table-column prop="description" label="描述" /> -->
        <el-table-column prop="createtime" label="创建时间" width="160" />
        <!-- <el-table-column prop="updatetime" label="更新时间" width="160" /> -->
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="{row}">
            <el-button 
              v-if="row.status == 1" 
              type="primary" 
              size="mini" 
              @click="handleEdit(row)"
            >编辑</el-button>
            <el-button 
              v-if="row.status == 1" 
              type="danger" 
              size="mini" 
              @click="handleDelete(row)"
            >删除</el-button>
            <el-button 
              v-if="row.status == 1" 
              type="success" 
              size="mini" 
              @click="handleGenerateTicket(row)"
            >生成准考证</el-button>
            <el-button 
              v-else 
              type="info" 
              size="mini" 
              disabled
            >已生成准考证</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="query.limit"
          :current-page.sync="query.page"
          @current-change="getList"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50]"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { getExamList, deleteExam, batchDeleteExam, exportExam ,generateAdmissionTicket} from '@/api/exam'
import { getAllSessionList } from '@/api/recruitment-session'

export default {
  name: 'ExamList',
  data() {
    return {
      query: {
        page: 1,
        limit: 20,
        exam_name: '',
        session_id: ''
      },
      list: [],
      total: 0,
      loading: false,
      multipleSelection: [],
      sessionOptions: []
    }
  },
  created() {
    this.getSessionOptions()
    this.getList()
  },
  methods: {
    async getSessionOptions() {
      try {
        const res = await getAllSessionList()
        this.sessionOptions = res.data.list
      } catch (e) {
        this.sessionOptions = []
      }
    },
    async getList() {
      this.loading = true
      try {
        const res = await getExamList(this.query)
        this.list = res.data.list
        this.total = res.data.total
      } catch (e) {
        this.list = []
        this.total = 0
      }
      this.loading = false
    },
    handleCreate() {
      this.$router.push({ path: '/exam/edit' })
    },
    handleEdit(row) {
      this.$router.push({ path: `/exam/edit/${row.id}` })
    },
    handleDelete(row) {
      this.$confirm('确定删除该考试科目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteExam(row.id)
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleBatchDelete() {
      this.$confirm('确定批量删除选中的考试科目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ids = this.multipleSelection.map(item => item.id)
        await batchDeleteExam(ids)
        this.$message.success('批量删除成功')
        this.getList()
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.query.limit = val
      this.getList()
    },
    handleReset() {
      this.query.exam_name = ''
      this.query.session_id = ''
      this.query.page = 1
      this.getList()
    },
    async handleExport() {
      try {
        const res = await exportExam(this.query)
        const isCSV = res.type.includes('csv')
        if (!isCSV) {
          const text = await res.text()
          let msg = '导出失败'
          try { msg = JSON.parse(text).msg || msg } catch (e) { msg = text }
          this.$message.error(msg)
          return
        }
        const url = window.URL.createObjectURL(res)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', '考试科目.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    handleGenerateTicket(row) {
      this.$confirm('生成准考证后，该考试信息将不能编辑和删除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // TODO: 调用生成准考证的API
          const res = await generateAdmissionTicket(row.id)
          if (res.code == 200) {
            this.$message.success('准考证生成成功')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        } catch (error) {
          this.$message.error('准考证生成失败')
        }
      }).catch(() => {
        this.$message.info('已取消生成准考证')
      })
    }
  }
}
</script>
<style scoped>
.filter-container { margin-bottom: 20px; }
.pagination-container { margin-top: 20px; text-align: right; }
.position-list, .room-list {
  max-height: 200px;
  overflow-y: auto;
}
.position-item, .room-item {
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}
.position-item:last-child, .room-item:last-child {
  border-bottom: none;
}
</style> 


// WEBPACK FOOTER //
// src/views/exam/ExamList.vue